import type { SavedGoal } from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/GoalField/types.js';
import { BuilderTableColumn, BuilderTableRow } from '../pages/Builder/types.js';

type Props = {
  row: BuilderTableRow;
  column: BuilderTableColumn;
};

type ValueType = string | number | null | SavedGoal;

type UpdateCellValueProps<T> = {
  currentValue: T;
  newValue: T;
};

export const useCellValueUpdate = ({ column, row }: Props) => {
  const updateCellValue = async <T extends ValueType>({
    currentValue,
    newValue,
  }: UpdateCellValueProps<T>): Promise<T> => {
    const { isError } = await column.updateRow(
      {
        id: row.original.id,
      },
      column.id,
      newValue,
    );

    if (isError) {
      return currentValue;
    }

    return newValue;
  };

  return { updateCellValue };
};
